import AxL from './axl';

class About {
  constructor(axl, translator) {
    this.axl = axl;
    this.translator = translator;
    this.iosEl = document.getElementById('ios-message');
    this.safariDesktopEl = document.getElementById('safari-desktop-message');
    this.el = document.getElementById('about');
    this.limitEl = document.getElementById('limit-message');
    this.openButton = document.getElementById('aboutbtn');
    this.closeButton = document.getElementById('aboutclosebtn');
    this.limitCloseButton = document.getElementById('limitclosebtn');
    this.magentaLinkElement = document.getElementById('magenta-link');
    // The scale infobox
    this.scaleInfo = {
      shown: false,
      current: 'standard',
      infoShown: {
        japanese: false,
        standard: false,
      },
      element: document.getElementById('scale-info'),
      text: document.querySelector('#scale-info p'),
      closeButton: document.getElementById('scaleclosebtn'),
      textJapanese:
        'This is a Hirajōshi scale, originated from Japan. Created by Yatsuhashi Kengyō, this scale was adapted from shamisen music and originally used for tuning the koto instrument.',
      textStandard:
        'This is a heptatonic scale, which means there are 7 notes per octave. The most commonly known heptatonic scales are the major and harmonic minor scales, widely used in Western music.',
    };
    this.openButton.addEventListener('click', this.toggle.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.scaleInfo.closeButton.addEventListener(
      'click',
      this.closeScaleInfo.bind(this)
    );
    this.closeButton.addEventListener('click', this.close.bind(this));
    this.magentaLinkElement.addEventListener('click', (e) => {
      if (this.axl) {
        e.preventDefault();
        this.axl.sendMessage(
          AxL.ChildToHost.NAVIGATE,
          this.magentaLinkElement.href
        );
      }
    });
  }

  start(isIos, isInShareMode = false) {
    if (isInShareMode) {
      this.iosEl.style.top = '72px';
      this.iosEl.style.bottom = 'auto';
    } else {
      this.iosEl.style.top = 'auto';
      this.iosEl.style.bottom = '120px';
    }
    if (isIos) {
      this.iosEl.style.display = 'block';
    }
  }

  toggle() {
    this.el.classList.toggle('shown');
  }

  open() {
    this.el.classList.add('shown');
  }

  openScaleInfo() {
    // do not show if we have already shown this info.
    this.scaleInfo.shown = true;
    if (this.scaleInfo.infoShown[this.scaleInfo.current] == true) return;
    this.scaleInfo.element.classList.add('shown');
    // record that the info about the scale has been given
  }

  toggleScaleInfo() {
    this.scaleInfo.element.classList.toggle('shown');
  }

  closeScaleInfo(e) {
    if (!this.scaleInfo.shown) return;
    if (e) this.scaleInfo.infoShown[this.scaleInfo.current] = true;
    this.scaleInfo.element.classList.remove('shown');
    if (this.axl && e) {
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: 'close_scale_info',
        label: 'OK',
      });
    }
    this.scaleInfo.shown = false;
  }

  changeScaleInfo(atmosphere) {
    if (atmosphere != 'japanese') {
      this.scaleInfo.text.textContent =
        this.translator.dictionary.info_scale || this.scaleInfo.textStandard;
      this.scaleInfo.current = 'standard';
    } else {
      this.scaleInfo.text.textContent =
        this.translator.dictionary.info_japanese_scale ||
        this.scaleInfo.textJapanese;
      this.scaleInfo.current = 'japanese';
    }
  }

  showSafariWarning() {
    this.safariDesktopEl.style.display = 'block';
  }

  changeColor(color, complementaryColor) {
    this.closeButton.style.backgroundColor = color;
    this.closeButton.style.color = complementaryColor;

    this.limitCloseButton.style.backgroundColor = color;
    this.limitCloseButton.style.color = complementaryColor;

    this.el.style.color = color;
    this.el.style.backgroundColor = complementaryColor;

    this.iosEl.style.color = color;
    this.iosEl.style.backgroundColor = complementaryColor;

    this.safariDesktopEl.style.color = color;
    this.safariDesktopEl.style.backgroundColor = complementaryColor;

    this.limitEl.style.color = color;
    this.limitEl.style.backgroundColor = complementaryColor;

    this.scaleInfo.element.style.color = color;
    this.scaleInfo.element.style.backgroundColor = complementaryColor;

    this.scaleInfo.closeButton.style.backgroundColor = color;
    this.scaleInfo.closeButton.style.color = complementaryColor;
  }

  close(e) {
    this.el.classList.remove('shown');
    if (this.axl && e) {
      this.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: 'close_about',
        label: 'OK',
      });
    }
  }
}

export { About };
